export default "__VITE_ASSET__DjKuejfg__"